export const environment = {
  production: true,
  WS_END_POINT : 'https://path-api-mobile.globalmediaoutreach.com/',
  SOCKET_END_POINT : 'https://path-api-socket.globalmediaoutreach.com/',
  BIBLE_KEY: '2ff95acf3188d428a46c8241805219a1',
  RECAPTCHA_SITE_KEY: '6LcX1lcdAAAAAKzNvZSwazAIkgoGIKvpzqd58lZI',
  WS_AUTHORIZATION: 'amNodW5nOmpjaHVuZw==',
  CATEGORY_UUID: '7438016a-b164-4007-8eb7-f7fb51b30ecf',
  RESPONSE_EXCEEDED_CONTACT_FACEBOOK_DAYS: 7,
  RESPONSE_EXCEEDED_CONTACT_WHATSAPP_DAYS: 1,
  GOSPEL_MIN_LENGTH: 500,
  TESTIMONY_MIN_LENGTH: 500,
  AUTO_ASSIGN_DURATION_IN_MINUTES: 30,
  IS_COPILOT_ENABLED: false,
  IS_COPILOT_SPIRITUAL_GROWTH_ENABLED: false,
  PDF_REMOTE_SERVER_URL : 'https://path.globalmediaoutreach.com'
};
